import React from "react";

import "./NavBar.scss";
import { NavLink } from "react-router-dom";
import { MoneyCorpPermissions } from "../../hooks/usePermissions/usePermissions";

const NavBar = (props: {
  title?: string;
  permissions?: MoneyCorpPermissions;
}) => {
  return (
    <>
      <div className="NavBar--container">
        {props.permissions &&
          (props.permissions.admin ||
            props.permissions.readCompanies ||
            props.permissions.readBranches) && (
            <div id="Admin-link-container" className="NavBar--link-container">
              <NavLink
                id="Navbar-link-admin"
                to="/admin"
                className="NavBar--link"
                activeStyle={{ color: "black" }}
              >
                Administration
              </NavLink>
            </div>
          )}
        {props.permissions && props.permissions.admin && (
          <div id="Config-link-container" className="NavBar--link-container">
            <NavLink
              id="Navbar-link-config"
              to="/config"
              className="NavBar--link"
              activeStyle={{ color: "black" }}
            >
              Configuration
            </NavLink>
          </div>
        )}
        <div
          id="OrderHistory-link-container"
          className="NavBar--link-container"
        >
          <NavLink
            id="Navbar-link-order-history"
            to="/orderHistory"
            className="NavBar--link"
            activeStyle={{ color: "black" }}
          >
            Order History
          </NavLink>
        </div>

        {props.permissions &&
          (props.permissions.invoicing || props.permissions.invoicesRead) && (
            <div
              id="Invoicing-link-container"
              className="NavBar--link-container"
            >
              <NavLink
                id="Navbar-link-invoicing"
                to="/invoicing"
                className="NavBar--link"
                activeStyle={{ color: "black" }}
              >
                Invoicing
              </NavLink>
            </div>
          )}

        {props.permissions && props.permissions.orderRaising && (
          <div id="NewOrder-link-container" className="NavBar--link-container">
            <NavLink
              id="Navbar-link-new-order"
              to="/newReturn"
              className="NavBar--link"
              activeStyle={{ color: "black" }}
            >
              New Return
            </NavLink>
          </div>
        )}

        {props.permissions && props.permissions.orderRaising && (
          <div id="NewOrder-link-container" className="NavBar--link-container">
            <NavLink
              id="Navbar-link-new-order"
              to="/newOrder"
              className="NavBar--link"
              activeStyle={{ color: "black" }}
            >
              New Order
            </NavLink>
          </div>
        )}

        <div className="NavBar--link-container">
          <a href="/logout" className="NavBar--link NavBar--link-no-border">
            Logout
          </a>
        </div>
      </div>
      <div className="NavBar--sectionHeader">{props.title}</div>
    </>
  );
};

export default NavBar;
